module.exports = "<p>\n  sitemap works!\n</p>\n"